export default __webpack_public_path__ + "static/media/article_img_01.a4ea34cc.png";